/* @flow */

import { compose } from 'ramda';
import { connect } from 'react-redux';
import {
  getEventSupportEmail,
  getEventForgotPasswordURL,
} from '@e180/domain/lib/event/util';

import SignupAuthenticationHelperDumb from './SignupAuthenticationHelperDumb';
import { supportEmail } from 'src/shared/app/base/settings/contactSettings';
import { getEventPublicData } from 'src/shared/domain/event/selector/eventSelectors';

import type { BraindateEvent } from '@e180/domain/lib/event/type';

type Props = {
  isPasswordSet: boolean,
};

const mapStateToProps = (state: Object, { isPasswordSet }: Props): Object => {
  // $FlowIssue
  const event: BraindateEvent = getEventPublicData(state);

  return {
    isPasswordSet,
    forgotPasswordURL: getEventForgotPasswordURL(event),
    supportEmail: getEventSupportEmail(event) || supportEmail,
  };
};

export default compose(connect(mapStateToProps))(
  SignupAuthenticationHelperDumb,
);
